/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Chat_Error_Reported_TicketInputs */



/**
* | output |
* | --- |
* | "Reported as #{number}. Thank you!" |
*
* @param {Chat_Error_Reported_TicketInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_reported_ticket = /** @type {((inputs: Chat_Error_Reported_TicketInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Reported_TicketInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Gemeldet als #${i?.number}. Danke!`)
	return /** @type {LocalizedString} */ (`Reported as #${i?.number}. Thank you!`)
});